export default __webpack_public_path__ + "media/images/elephant_ui_plane.svg";